import React, { useState, useEffect } from 'react';
import { db } from '../LoginComp/firebase';
import { collection, query, where, getDocs, orderBy, limit, startAfter, getCountFromServer } from 'firebase/firestore';

import './journal.css';

function ClinicalResource() {
  // State management
  const [clinicalresource, setClinicalresource] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [lastVisible, setLastVisible] = useState(null);

  // Fetch Journal Articles from Firestore -
  const fetchClinicalresources = async (page) => {
    try {
      const pageSize = 6; // Number of items per page
      const clinicalresourceRef = collection(db, 'mainresources');
      let q = query(
        clinicalresourceRef,
        where('resourceType', '==', 'Clinical Resource'),
        orderBy('created_at'),
        limit(pageSize)
      );

      if (page > 1 && lastVisible) {
        q = query(
          clinicalresourceRef,
          where('resourceType', '==', 'Clinical Resource'),
          orderBy('created_at'),
          startAfter(lastVisible),
          limit(pageSize)
        );
      }

      const querySnapshot = await getDocs(q);
      const clinicalresources = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      setClinicalresource(clinicalresources);
      setLastVisible(querySnapshot.docs[querySnapshot.docs.length - 1]);

      // Calculate total pages using count query
      const countSnapshot = await getCountFromServer(query(clinicalresourceRef, where('resourceType', '==', 'Clinical Resource')));
      const totalPages = Math.ceil(countSnapshot.data().count / pageSize);
      setTotalPages(totalPages);

    } catch (error) {
      console.error("Error fetching journal articles:", error);
    }
  };

  // Handle pagination click
  const paginate = (page) => {
    setCurrentPage(page);
    fetchClinicalresources(page);
  };

  useEffect(() => {
    fetchClinicalresources(currentPage);
  }, [currentPage]);

  return (
  <div className="journal-page-container">

    {/* HERO SECTION */}
    <section className="hero">

      <div className="hero-image">
        <img
          src="/imgbook.png"
          alt="Clinical Resources"
        />
      </div>

      <div className="hero-content">

        <h1>Eye Care Digital Library</h1>

        <p>
          Access professional clinical resources,
          ophthalmic reference materials,
          diagnostic guides, treatment protocols,
          and evidence-based eye care knowledge.
        </p>

      </div>

    </section>

    {/* PAGE HEADER */}
    <div className="journal-heading-section">

      <h2>Clinical Resources</h2>

      <p>
        Browse a curated collection of clinical
        ophthalmology resources including
        examination techniques, patient care
        procedures, diagnostic methods, disease
        management references, and professional
        healthcare education materials.
      </p>

    </div>

    {/* RESOURCES GRID */}
    <div className="articles-container">

      {clinicalresource.length > 0 ? (

        clinicalresource.map((resource) => (

          <div
            key={resource.id}
            className="article-item"
          >

            {/* COVER IMAGE */}
            {resource.coverImageURL && (
              <img
                src={resource.coverImageURL}
                alt={resource.title}
                className="book-cover-image"
              />
            )}

            {/* CONTENT */}
            <div className="article-content">

              {/* TITLE */}
              <h4>{resource.title}</h4>

              {/* META DETAILS */}
              <div className="book-meta-data">

                {resource.author && (
                  <p>
                    <strong>Author:</strong>{" "}
                    {resource.author}
                  </p>
                )}

                {resource.publication_year && (
                  <p>
                    <strong>Year:</strong>{" "}
                    {resource.publication_year}
                  </p>
                )}

                {resource.isbn && (
                  <p>
                    <strong>ISBN:</strong>{" "}
                    {resource.isbn}
                  </p>
                )}

              </div>

              {/* DESCRIPTION */}
              {resource.description && (
                <p className="book-description">
                  {resource.description}
                </p>
              )}

              {/* BUTTON */}
              {resource.pdfFileURL && (
                <a
                  href={resource.pdfFileURL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="read-article-btn"
                >
                  Read Clinical Resource
                </a>
              )}

            </div>

          </div>

        ))

      ) : (

        <div className="no-books-found">

          <h3>No Clinical Resources Available</h3>

          <p>
            No clinical ophthalmology resources
            have been uploaded yet.
          </p>

        </div>

      )}

    </div>

    {/* PAGINATION */}
    {totalPages > 1 && (

      <div className="pagination-container">

        <button
          className="pagination-button"
          onClick={() =>
            paginate(currentPage - 1)
          }
          disabled={currentPage === 1}
        >
          Previous
        </button>

        {Array.from(
          { length: totalPages },
          (_, index) => (

            <button
              key={index + 1}
              className={`pagination-button ${
                currentPage === index + 1
                  ? 'active'
                  : ''
              }`}
              onClick={() =>
                paginate(index + 1)
              }
            >
              {index + 1}
            </button>

          )
        )}

        <button
          className="pagination-button"
          onClick={() =>
            paginate(currentPage + 1)
          }
          disabled={
            currentPage === totalPages
          }
        >
          Next
        </button>

      </div>

    )}

  </div>
);
}

export default ClinicalResource